module.exports = __webpack_public_path__ + "img/7_2.2fd929f7.png";